export const LATLNG_DD_FORMAT: RegExp = new RegExp([
  `^[-+]?([1-8]?\\d(\\.\\d+)?|90(\\.0+)?)\\s*,\\s*[-+]?(180(\\.0+)?`,
  `|((1[0-7]\\d)|([1-9]?\\d))(\\.\\d+)?)$`,
].join(''));

export const LATLNG_DMS_FORMAT: RegExp = new RegExp([
  `([0-9]{1,2})\\s*[:|°]\\s*([0-9]{1,2})\\s*[:|'|′]\\s*?([0-9]{1,2}(?:\\.[0-9]+){0,1})\\s*?`,
  `["|″]\\s*([N|S])\\s*([0-9]{1,3})\\s*[:|°]\\s*([0-9]{1,2})\\s*[:|'|′]\\s*?([0-9]{1,2}(?:\\.[0-9]+){0,1})\\s*?["|″]\\s*([E|W])`,
].join(''));

export const LATLNG_DMM_FORMAT: RegExp = new RegExp([
  `^([-+]?)([\\d]{1,2})(((\\s)([0-9]{1,2}(?:\\.[0-9]+){0,1})(\\s*)(,)))(\\s*)([-+]?)`,
  `([\\d]{1,2})(((\\s)([0-9]{1,2}(?:\\.[0-9]+){0,1})(\\s*)))`,
].join(''));

export function convertDMMtoDD(value: string): number {
  let result: number;
  let degrees: number;
  let minutes: number;
  degrees = +value.split(' ')[0].trim();
  value = value.split(' ')[1].trim();

  minutes = +value;
  result = degrees + (degrees < 0 ? (-minutes / 60) : (minutes / 60));
  return result;
}

export function convertDMStoDD(value: string, isNegative: boolean): number {
  let result: number;
  let degrees: number;
  let minutes: number;
  let seconds: number;
  degrees = +value.split('°')[0].trim();
  value = value.split('°')[1].trim();

  minutes = +value.split(`'`)[0].trim();
  seconds = +value.split(`'`)[1].trim();
  result = degrees + (minutes / 60) + (seconds / 3600);
  if (!isNegative) result *= -1;
  return result;
}
